import * as React from 'react';
import classnames from 'classnames';

import './access-container.scss';

import type {
  AccessType
} from 'types';

type Props = {
  type: AccessType,
  children: React.ReactNode
};

const AccessContainer = (
  {
    type,
    children
  }: Props
): JSX.Element => {
  const containerClasses = classnames({
    'access-container': true,
    [`access-container--type-${type}`]: type
  });

  const childrenClasses = classnames({
    'access-container__children': true,
    [`access-container__children--type-${type}`]: type,
    'access-container__children--no-side-paddings': type === 'signup' || type === 'influencer-signup',
    'access-container__children--no-bottom-paddings': type === 'influencer-signup'
  });

  return (
    <div
      className={containerClasses}
      data-qa={`container-${type}`}
    >
      <div className={childrenClasses}>
        {children}
      </div>
    </div>
  );
};

export default AccessContainer;
